module.exports = __webpack_public_path__ + "static/media/correcto.711c3a7d.PNG";